import xe, { useRef as U, useEffect as B } from "react";
import * as Ce from "monaco-editor";
var q = { exports: {} }, $ = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pe;
function gr() {
  if (Pe) return $;
  Pe = 1;
  var E = xe, h = Symbol.for("react.element"), w = Symbol.for("react.fragment"), b = Object.prototype.hasOwnProperty, C = E.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, T = { key: !0, ref: !0, __self: !0, __source: !0 };
  function O(y, f, S) {
    var v, s = {}, l = null, m = null;
    S !== void 0 && (l = "" + S), f.key !== void 0 && (l = "" + f.key), f.ref !== void 0 && (m = f.ref);
    for (v in f) b.call(f, v) && !T.hasOwnProperty(v) && (s[v] = f[v]);
    if (y && y.defaultProps) for (v in f = y.defaultProps, f) s[v] === void 0 && (s[v] = f[v]);
    return { $$typeof: h, type: y, key: l, ref: m, props: s, _owner: C.current };
  }
  return $.Fragment = w, $.jsx = O, $.jsxs = O, $;
}
var L = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var we;
function _r() {
  return we || (we = 1, process.env.NODE_ENV !== "production" && function() {
    var E = xe, h = Symbol.for("react.element"), w = Symbol.for("react.portal"), b = Symbol.for("react.fragment"), C = Symbol.for("react.strict_mode"), T = Symbol.for("react.profiler"), O = Symbol.for("react.provider"), y = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), S = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), s = Symbol.for("react.memo"), l = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), F = Symbol.iterator, De = "@@iterator";
    function Ae(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = F && e[F] || e[De];
      return typeof r == "function" ? r : null;
    }
    var k = E.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function p(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
          t[n - 1] = arguments[n];
        Fe("error", e, t);
      }
    }
    function Fe(e, r, t) {
      {
        var n = k.ReactDebugCurrentFrame, i = n.getStackAddendum();
        i !== "" && (r += "%s", t = t.concat([i]));
        var u = t.map(function(o) {
          return String(o);
        });
        u.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, u);
      }
    }
    var Ie = !1, Me = !1, $e = !1, Le = !1, Ye = !1, re;
    re = Symbol.for("react.module.reference");
    function We(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === b || e === T || Ye || e === C || e === S || e === v || Le || e === m || Ie || Me || $e || typeof e == "object" && e !== null && (e.$$typeof === l || e.$$typeof === s || e.$$typeof === O || e.$$typeof === y || e.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === re || e.getModuleId !== void 0));
    }
    function Ve(e, r, t) {
      var n = e.displayName;
      if (n)
        return n;
      var i = r.displayName || r.name || "";
      return i !== "" ? t + "(" + i + ")" : t;
    }
    function te(e) {
      return e.displayName || "Context";
    }
    function P(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && p("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case b:
          return "Fragment";
        case w:
          return "Portal";
        case T:
          return "Profiler";
        case C:
          return "StrictMode";
        case S:
          return "Suspense";
        case v:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case y:
            var r = e;
            return te(r) + ".Consumer";
          case O:
            var t = e;
            return te(t._context) + ".Provider";
          case f:
            return Ve(e, e.render, "ForwardRef");
          case s:
            var n = e.displayName || null;
            return n !== null ? n : P(e.type) || "Memo";
          case l: {
            var i = e, u = i._payload, o = i._init;
            try {
              return P(o(u));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var j = Object.assign, I = 0, ne, ae, oe, ie, ue, se, ce;
    function fe() {
    }
    fe.__reactDisabledLog = !0;
    function Ne() {
      {
        if (I === 0) {
          ne = console.log, ae = console.info, oe = console.warn, ie = console.error, ue = console.group, se = console.groupCollapsed, ce = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: fe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        I++;
      }
    }
    function Ue() {
      {
        if (I--, I === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: j({}, e, {
              value: ne
            }),
            info: j({}, e, {
              value: ae
            }),
            warn: j({}, e, {
              value: oe
            }),
            error: j({}, e, {
              value: ie
            }),
            group: j({}, e, {
              value: ue
            }),
            groupCollapsed: j({}, e, {
              value: se
            }),
            groupEnd: j({}, e, {
              value: ce
            })
          });
        }
        I < 0 && p("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var J = k.ReactCurrentDispatcher, G;
    function Y(e, r, t) {
      {
        if (G === void 0)
          try {
            throw Error();
          } catch (i) {
            var n = i.stack.trim().match(/\n( *(at )?)/);
            G = n && n[1] || "";
          }
        return `
` + G + e;
      }
    }
    var K = !1, W;
    {
      var Be = typeof WeakMap == "function" ? WeakMap : Map;
      W = new Be();
    }
    function le(e, r) {
      if (!e || K)
        return "";
      {
        var t = W.get(e);
        if (t !== void 0)
          return t;
      }
      var n;
      K = !0;
      var i = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var u;
      u = J.current, J.current = null, Ne();
      try {
        if (r) {
          var o = function() {
            throw Error();
          };
          if (Object.defineProperty(o.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(o, []);
            } catch (_) {
              n = _;
            }
            Reflect.construct(e, [], o);
          } else {
            try {
              o.call();
            } catch (_) {
              n = _;
            }
            e.call(o.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (_) {
            n = _;
          }
          e();
        }
      } catch (_) {
        if (_ && n && typeof _.stack == "string") {
          for (var a = _.stack.split(`
`), g = n.stack.split(`
`), c = a.length - 1, d = g.length - 1; c >= 1 && d >= 0 && a[c] !== g[d]; )
            d--;
          for (; c >= 1 && d >= 0; c--, d--)
            if (a[c] !== g[d]) {
              if (c !== 1 || d !== 1)
                do
                  if (c--, d--, d < 0 || a[c] !== g[d]) {
                    var R = `
` + a[c].replace(" at new ", " at ");
                    return e.displayName && R.includes("<anonymous>") && (R = R.replace("<anonymous>", e.displayName)), typeof e == "function" && W.set(e, R), R;
                  }
                while (c >= 1 && d >= 0);
              break;
            }
        }
      } finally {
        K = !1, J.current = u, Ue(), Error.prepareStackTrace = i;
      }
      var A = e ? e.displayName || e.name : "", x = A ? Y(A) : "";
      return typeof e == "function" && W.set(e, x), x;
    }
    function qe(e, r, t) {
      return le(e, !1);
    }
    function Je(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function V(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return le(e, Je(e));
      if (typeof e == "string")
        return Y(e);
      switch (e) {
        case S:
          return Y("Suspense");
        case v:
          return Y("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case f:
            return qe(e.render);
          case s:
            return V(e.type, r, t);
          case l: {
            var n = e, i = n._payload, u = n._init;
            try {
              return V(u(i), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var M = Object.prototype.hasOwnProperty, de = {}, ve = k.ReactDebugCurrentFrame;
    function N(e) {
      if (e) {
        var r = e._owner, t = V(e.type, e._source, r ? r.type : null);
        ve.setExtraStackFrame(t);
      } else
        ve.setExtraStackFrame(null);
    }
    function Ge(e, r, t, n, i) {
      {
        var u = Function.call.bind(M);
        for (var o in e)
          if (u(e, o)) {
            var a = void 0;
            try {
              if (typeof e[o] != "function") {
                var g = Error((n || "React class") + ": " + t + " type `" + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[o] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw g.name = "Invariant Violation", g;
              }
              a = e[o](r, o, n, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (c) {
              a = c;
            }
            a && !(a instanceof Error) && (N(i), p("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", n || "React class", t, o, typeof a), N(null)), a instanceof Error && !(a.message in de) && (de[a.message] = !0, N(i), p("Failed %s type: %s", t, a.message), N(null));
          }
      }
    }
    var Ke = Array.isArray;
    function z(e) {
      return Ke(e);
    }
    function ze(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function He(e) {
      try {
        return pe(e), !1;
      } catch {
        return !0;
      }
    }
    function pe(e) {
      return "" + e;
    }
    function ge(e) {
      if (He(e))
        return p("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ze(e)), pe(e);
    }
    var _e = k.ReactCurrentOwner, Xe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ee, Re;
    function Ze(e) {
      if (M.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function Qe(e) {
      if (M.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function er(e, r) {
      typeof e.ref == "string" && _e.current;
    }
    function rr(e, r) {
      {
        var t = function() {
          Ee || (Ee = !0, p("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function tr(e, r) {
      {
        var t = function() {
          Re || (Re = !0, p("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var nr = function(e, r, t, n, i, u, o) {
      var a = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: h,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: t,
        props: o,
        // Record the component responsible for creating this element.
        _owner: u
      };
      return a._store = {}, Object.defineProperty(a._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(a, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: n
      }), Object.defineProperty(a, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: i
      }), Object.freeze && (Object.freeze(a.props), Object.freeze(a)), a;
    };
    function ar(e, r, t, n, i) {
      {
        var u, o = {}, a = null, g = null;
        t !== void 0 && (ge(t), a = "" + t), Qe(r) && (ge(r.key), a = "" + r.key), Ze(r) && (g = r.ref, er(r, i));
        for (u in r)
          M.call(r, u) && !Xe.hasOwnProperty(u) && (o[u] = r[u]);
        if (e && e.defaultProps) {
          var c = e.defaultProps;
          for (u in c)
            o[u] === void 0 && (o[u] = c[u]);
        }
        if (a || g) {
          var d = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          a && rr(o, d), g && tr(o, d);
        }
        return nr(e, a, g, i, n, _e.current, o);
      }
    }
    var H = k.ReactCurrentOwner, he = k.ReactDebugCurrentFrame;
    function D(e) {
      if (e) {
        var r = e._owner, t = V(e.type, e._source, r ? r.type : null);
        he.setExtraStackFrame(t);
      } else
        he.setExtraStackFrame(null);
    }
    var X;
    X = !1;
    function Z(e) {
      return typeof e == "object" && e !== null && e.$$typeof === h;
    }
    function be() {
      {
        if (H.current) {
          var e = P(H.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function or(e) {
      return "";
    }
    var ye = {};
    function ir(e) {
      {
        var r = be();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function me(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = ir(r);
        if (ye[t])
          return;
        ye[t] = !0;
        var n = "";
        e && e._owner && e._owner !== H.current && (n = " It was passed a child from " + P(e._owner.type) + "."), D(e), p('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, n), D(null);
      }
    }
    function Te(e, r) {
      {
        if (typeof e != "object")
          return;
        if (z(e))
          for (var t = 0; t < e.length; t++) {
            var n = e[t];
            Z(n) && me(n, r);
          }
        else if (Z(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var i = Ae(e);
          if (typeof i == "function" && i !== e.entries)
            for (var u = i.call(e), o; !(o = u.next()).done; )
              Z(o.value) && me(o.value, r);
        }
      }
    }
    function ur(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === s))
          t = r.propTypes;
        else
          return;
        if (t) {
          var n = P(r);
          Ge(t, e.props, "prop", n, e);
        } else if (r.PropTypes !== void 0 && !X) {
          X = !0;
          var i = P(r);
          p("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", i || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && p("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function sr(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var n = r[t];
          if (n !== "children" && n !== "key") {
            D(e), p("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", n), D(null);
            break;
          }
        }
        e.ref !== null && (D(e), p("Invalid attribute `ref` supplied to `React.Fragment`."), D(null));
      }
    }
    var Oe = {};
    function Se(e, r, t, n, i, u) {
      {
        var o = We(e);
        if (!o) {
          var a = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (a += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var g = or();
          g ? a += g : a += be();
          var c;
          e === null ? c = "null" : z(e) ? c = "array" : e !== void 0 && e.$$typeof === h ? (c = "<" + (P(e.type) || "Unknown") + " />", a = " Did you accidentally export a JSX literal instead of a component?") : c = typeof e, p("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", c, a);
        }
        var d = ar(e, r, t, i, u);
        if (d == null)
          return d;
        if (o) {
          var R = r.children;
          if (R !== void 0)
            if (n)
              if (z(R)) {
                for (var A = 0; A < R.length; A++)
                  Te(R[A], e);
                Object.freeze && Object.freeze(R);
              } else
                p("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Te(R, e);
        }
        if (M.call(r, "key")) {
          var x = P(e), _ = Object.keys(r).filter(function(pr) {
            return pr !== "key";
          }), Q = _.length > 0 ? "{key: someKey, " + _.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Oe[x + Q]) {
            var vr = _.length > 0 ? "{" + _.join(": ..., ") + ": ...}" : "{}";
            p(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Q, x, vr, x), Oe[x + Q] = !0;
          }
        }
        return e === b ? sr(d) : ur(d), d;
      }
    }
    function cr(e, r, t) {
      return Se(e, r, t, !0);
    }
    function fr(e, r, t) {
      return Se(e, r, t, !1);
    }
    var lr = fr, dr = cr;
    L.Fragment = b, L.jsx = lr, L.jsxs = dr;
  }()), L;
}
var je;
function Er() {
  return je || (je = 1, process.env.NODE_ENV === "production" ? q.exports = gr() : q.exports = _r()), q.exports;
}
var Rr = Er();
const br = ({
  value: E,
  language: h,
  height: w = "100%",
  width: b = "100%",
  options: C,
  onChange: T,
  onMount: O
}) => {
  const y = U(null), f = U(null), S = U(!0), v = U(E);
  return B(() => {
    if (y.current) {
      const s = Ce.editor.create(y.current, {
        value: E,
        language: h,
        automaticLayout: !0,
        //      model,
        ...C
      });
      f.current = s, O && O(s);
      const l = s.getModel(), m = l == null ? void 0 : l.onDidChangeContent(() => {
        if (T && l) {
          const F = l.getValue();
          v.current = F, T(F);
        }
      });
      return () => {
        m == null || m.dispose(), S.current = !1;
      };
    }
  }, []), B(() => () => {
    var s;
    (s = f.current) == null || s.dispose();
  }, []), B(() => {
    if (!S.current) return;
    const s = f.current;
    if (!s || s._isDisposed) return;
    const l = s.getModel();
    if (!(!l || l.isDisposed()) && E !== v.current) {
      const m = s.getPosition();
      l.setValue(E), v.current = E, m && s.setPosition(m);
    }
  }, [E]), B(() => {
    if (!S.current) return;
    const s = f.current;
    if (s) {
      const l = s.getModel();
      l && Ce.editor.setModelLanguage(l, h);
    }
  }, [h]), /* @__PURE__ */ Rr.jsx("div", { ref: y, style: { height: w, width: b } });
}, ke = Symbol.for("OPEN_RPC_GLOBAL_SCHEMA_DIAGNOSTICS"), ee = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  globalThis[ke] || {}
);
globalThis[ke] = ee;
function yr(E, h, w, b) {
  ee[E] = h;
  const C = {
    enableSchemaRequest: !0,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    schemas: Object.entries(ee).map(([T, O]) => ({
      fileMatch: b || [T],
      schema: O,
      uri: T
    })),
    validate: !0
  };
  w.languages.json.jsonDefaults.setDiagnosticsOptions(C);
}
export {
  br as MonacoEditor,
  yr as addDiagnostics
};
